import { requiredEnv } from './requiredEnv';

/**
 * Credits API client
 * Handles credit balance fetching and checkout session creation
 */

const BACKEND_URL = requiredEnv('REACT_APP_BACKEND_URL');

/**
 * Get user's credit balance
 * @param {Object} user - Firebase user object
 * @returns {Promise<{balance: number, created_at: string, updated_at: string, is_admin?: boolean}>}
 */
export async function getCreditBalance(user) {
  const idToken = await user.getIdToken();

  const response = await fetch(`${BACKEND_URL}/credits/balance`, {
    method: 'GET',
    headers: {
      'Authorization': `Bearer ${idToken}`,
      'Content-Type': 'application/json',
    },
  });

  if (!response.ok) {
    const errorData = await response.json().catch(() => ({}));
    throw new Error(errorData.error || `Failed to fetch balance: ${response.status}`);
  }

  return await response.json();
}

/**
 * Create Stripe checkout session
 * @param {Object} user - Firebase user object
 * @param {string} packageId - Credit package ID (credits_100, credits_250, credits_600)
 * @returns {Promise<{sessionId: string, url: string}>}
 */
export async function createCheckoutSession(user, packageId) {
  const idToken = await user.getIdToken();

  const response = await fetch(`${BACKEND_URL}/create-checkout-session`, {
    method: 'POST',
    headers: {
      'Authorization': `Bearer ${idToken}`,
      'Content-Type': 'application/json',
    },
    body: JSON.stringify({ packageId }),
  });

  if (!response.ok) {
    const errorData = await response.json().catch(() => ({}));
    throw new Error(errorData.error || `Failed to create checkout: ${response.status}`);
  }

  return await response.json();
}

// Credit packages for display
export const CREDIT_PACKAGES = [
  { id: 'credits_100', credits: 100, price: 5, label: '$5' },
  { id: 'credits_250', credits: 250, price: 10, label: '$10', badge: 'Best Value' },
  { id: 'credits_600', credits: 600, price: 20, label: '$20' },
];
